/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * CPA記録タイミング
 */
export type TreatmentCPADataTimingEnum =
  (typeof TreatmentCPADataTimingEnum)[keyof typeof TreatmentCPADataTimingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentCPADataTimingEnum = {
  PRESENT: 'PRESENT',
  ABSENT: 'ABSENT',
  AFTER_ARRIVAL: 'AFTER_ARRIVAL',
} as const;
